module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/event-components/notification-event-list/notification-event-list.component.css
// module id = ./src/app/event-components/notification-event-list/notification-event-list.component.css
// module chunks = main